import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { makeStyles, useTheme } from '@material-ui/styles';
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Typography
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  chartContainer: {
    position: 'relative',
    height: '300px'
  },
}));

const AdstodVegnaDoughnut = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const { talning, embaetti } = props;
  let chartData = {
    datasets: [
      {
        data: [],
        backgroundColor: [theme.palette.primary.main, theme.palette.error.main],
        borderWidth: 4,
        borderColor: theme.palette.white,
        hoverBorderColor: theme.palette.white
      }
    ],
    labels: ["Sjónleysi", "Ónothæf hönd"]
  };

  // Push updated data into the chart dataset
  if (talning.fjoldiAdstodBlindur !== undefined) {
    chartData.datasets.forEach(dataset => {
      dataset.data.push(talning.fjoldiAdstodBlindur.alls);
      dataset.data.push(talning.fjoldiAdstodHond.alls);
    });
  }

  const options = {
    legend: {
      display: true
    },
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    cutoutPercentage: 80,
    layout: { padding: 0 },
    tooltips: {
      enabled: true,
      mode: 'index',
      intersect: false,
      borderWidth: 1,
    }
  };

  return (
    <Card>
      <CardHeader title="Aðstoð vegna" subheader={embaetti}/>
      <Divider />
      <CardContent>
        {talning.fjoldiAdstodBlindur !== undefined ? (
        <div className={classes.chartContainer}>
          <Doughnut data={chartData} options={options} />
        </div>
        ) : (
          <Typography>Engin gögn fundust</Typography>
        )}
      </CardContent>
    </Card>
  );
}

export default AdstodVegnaDoughnut;